import { QRrecorder } from "component/qr/QRreader";

export function ScanQR(){
    return(
        <QRrecorder />
    )
}